import { RouteObject } from "react-router-dom";

const KpiConfigurationRoutes: RouteObject[] = [
	{ path: "/kpi-konfiguracija", lazy: () => import("@/pages/Reports/KpiConfigurationPage") },
];

export default KpiConfigurationRoutes;
